import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";

import Home from "@/pages/public/Home";
import QuoteRequest from "@/pages/public/QuoteRequest";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import Events from "@/pages/admin/Events";
import EventDetail from "@/pages/admin/EventDetail";
import CalendarPage from "@/pages/admin/CalendarPage";
import Analytics from "@/pages/admin/Analytics";
import Settings from "@/pages/admin/Settings";
import SignContract from "@/pages/public/SignContract";
import QuoteView from "@/pages/public/QuoteView";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<QuoteRequest />} />
          <Route path="/sign/:token" element={<SignContract />} />
          <Route path="/quote-view/:token" element={<QuoteView />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="events" element={<Events />} />
            <Route path="events/:id" element={<EventDetail />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
